import dayjs from "@onair/utils/dayjs";
import Link from "next/link";
import { memo } from "react";
interface CardPostVerticalProps {
	thunmbnailUrl?: string;
	title?: string | React.ReactNode;
	authorAvatarUrl?: string;
	authorName?: string;
	createdAt?: string;
	data: any;
	categories?: { id: number; title: string }[];
	description?: string;
	slug?: string;
}
const CardPostVertical: React.FC<CardPostVerticalProps> = ({
	thunmbnailUrl,
	title,
	authorAvatarUrl,
	authorName,
	slug,
	createdAt,
	description = "",
	categories = [],
}) => {
	const alternativeText = typeof title === "string" ? title : "";
	return (
		<div className="card-post-vertical">
			<Link href={`/post/${slug}`}>
				<div className="grid grid-cols-1 md:grid-cols-2 bg-gray-100 items-center">
					<div className="thumbnanail aspect-[9/5] overflow-hidden">
						{thunmbnailUrl ? (
							<img
								src={thunmbnailUrl}
								alt={alternativeText}
								className="w-full h-full object-cover"
							/>
						) : (
							<div className="flex items-center justify-center w-full h-full">
								<span>No Image</span>
							</div>
						)}
					</div>
					<div className="content p-6">
						<div className="flex items-center justify-between mb-6">
							<div className="flex gap-x-2 categories">
								{categories.map((cat, _index) => (
									<h4
										key={_index}
										className="bg-gray-200 text-gray-600 w-fit rounded-lg px-3 text-sm font-semibold py-0.5"
									>
										{cat?.title}
									</h4>
								))}
							</div>
							<div className="post-meta-time">
								<time className="text-gray-600 text-sm" dateTime={createdAt}>
									{dayjs(createdAt).format("DD [tháng] MM, YYYY")}
								</time>
							</div>
						</div>
						<h3 className="font-bold text-3xl mb-6">{title}</h3>
						<div
							className="line-clamp-3"
							dangerouslySetInnerHTML={{
								__html: description,
							}}
						/>
					</div>
				</div>
			</Link>
		</div>
	);
};

export default memo(CardPostVertical);
